'use client';

import { NOT_FOUND } from '@/app/lib/constants/literals';
import { useEffect } from 'react';

const SetNotFoundTitle = () => {
  useEffect(() => {
    document.title = NOT_FOUND; // ← Принудительно обновляем title, баг Next.js
  }, []);

  return null;
};

export default SetNotFoundTitle;
